import React from 'react';
import Footer from './Footer';
import Header from './Header';

const Contact = () => {
    return (
        <>
        <Header/>
        <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
            <div className="bg-gradient-to-r from-slate-800 to-slate-700 text-white py-20">
                <div className="max-w-7xl mx-auto px-6">
                    <h1 className="text-5xl font-bold mb-4">Contact Us</h1>
                    <p className="text-xl text-slate-200">Get in touch with our team</p>
                </div>
            </div>

            <div className="max-w-7xl mx-auto px-6 py-16">
                <div className="bg-white rounded-xl shadow-lg p-12 text-center">
                    <h2 className="text-3xl font-bold text-slate-800 mb-4">Contact Page</h2>
                    <p className="text-slate-600 text-lg">Reach out to our team for sales inquiries, technical support, partnership opportunities, or any questions about  services</p>
                    <h3 className="ext-2xl font-bold text-slate-800 mb-4">info@viewwiser.com</h3>
                </div>
            </div>
        </div>
        <Footer/>
        </>
    );
};

export default Contact;